import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { Create, useTranslate } from 'react-admin'
import { useFormState } from 'react-hook-form'
import { makeStyles } from 'tss-react/mui'
import { injectElement, reduceProps } from '~/helpers'

/**
 * react-hook-form has no <FormSpy>; isDirty is read from the form state
 * and pushed up through an effect instead.
 */
const DirtyWatcher = ({ onDirtyChange }) => {
  const { isDirty } = useFormState()
  React.useEffect(() => {
    onDirtyChange(isDirty)
  }, [isDirty, onDirtyChange])
  return null
}

/*
 * Custom css for dialog
 */
const useStyles = makeStyles()({
  scrollPaper: {
    alignItems: 'baseline',
  },
  root: {
    '& div.MuiDialogContent-root': {
      padding: 0,
    },
  },
})

/*
 * CreateModal
 */
const CreateModal = (props) => {
  const { fullWidth, title, children, state, open, onClose, ...rest } = props
  const [openState, setOpen] = state || []
  const translate = useTranslate()
  const [dirtyState, setDirtyState] = React.useState(false)

  const handleClose = () => {
    if (dirtyState) {
      if (window.confirm(translate('ra.message.unsaved_changes')))
        state ? setOpen(false) : onClose()
    } else {
      state ? setOpen(false) : onClose()
    }
  }

  const inject = <DirtyWatcher onDirtyChange={setDirtyState} />

  return (
    <Dialog
      // fullWidth={fullWidth}
      open={state ? openState : open}
      onClose={handleClose}
      aria-label={title}
      classes={useStyles()}
      maxWidth='md'
      fullWidth={true}
    >
      <DialogTitle>{translate(title)}</DialogTitle>
      <DialogContent>
        <Create {...reduceProps(rest)} component='div' redirect={false}>
          {injectElement(children, inject, ['SimpleForm', 'FormTab'])}
        </Create>
      </DialogContent>
    </Dialog>
  )
}

export default CreateModal
